<greco-collapsible-section
  *ngIf="subscription"
  id="subscription-schedule-section"
  [header]="{ title: 'Schedule', icon: 'schedule' }"
  [disabled]="disabled"
>
  <ng-container
    header
    *ngIf="
      (subscription.status === 'ACTIVE' || subscription.status === 'FROZEN') &&
      (canCancel || canMakeChange || canFreeze)
    "
  >
    <button mat-icon-button [matMenuTriggerFor]="optionsMenu" (click)="$event.stopImmediatePropagation()">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #optionsMenu>
      <button *ngIf="canCancel" mat-menu-item (click)="cancelSubscription()">
        <mat-icon>cancel</mat-icon>
        <span>Cancel</span>
      </button>
      <ng-container *ngIf="canUpdateSubscription$ | async">
        <button *ngIf="subscription.status !== 'FROZEN' && canMakeChange" mat-menu-item (click)="updateSubscription()">
          <mat-icon>update</mat-icon>
          <span>Update</span>
        </button>
      </ng-container>
      <button mat-menu-item *ngIf="subscription.status === 'ACTIVE' && canFreeze" (click)="freezeSubscription()">
        <mat-icon>pause_circle_outline</mat-icon>
        <span>Freeze</span>
      </button>
      <button mat-menu-item *ngIf="subscription.status === 'ACTIVE' && (isSuperAdmin$ | async)" (click)="fixPerks()">
        <mat-icon>construction</mat-icon>
        <span>Fix Perks (Super Admin)</span>
      </button>

      <ng-container *grecoLet="currentFreezes$ | async as currentFreezes">
        <button
          mat-menu-item
          (click)="unfreezeSubscription(currentFreezes || [])"
          *ngIf="subscription.status === 'FROZEN' && canFreeze"
        >
          <mat-icon>play_circle_outline</mat-icon>
          <span>Unfreeze</span>
        </button>
      </ng-container>

      <!-- action forces process even when subscription is locked -->
      <button *ngIf="canManuallyForceProcess$ | async" mat-menu-item (click)="forceProcessSubscription()">
        <mat-icon>construction</mat-icon>
        <span>Force process</span>
      </button>

      <!-- action does not force process when subscription is locked, used for when an action just didn't trigger -->
      <ng-container *ngIf="canTriggerSubscription$ | async">
        <button *ngIf="canManuallyTryProcess$ | async" mat-menu-item (click)="tryProcessSubscription()">
          <mat-icon>construction</mat-icon>
          <span>Trigger process</span>
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>

  <greco-table [data]="(actions$ | async) || []" [loading]="_loading">
    <mat-icon *grecoTableCol="''; let action; fitContent: true" [matTooltip]="action.id" [class]="action.status">
      {{
        $any({
          START: 'start',
          RENEWAL: 'loop',
          UPDATE: 'update',
          CANCELLATION: 'cancel',
          FREEZE: 'pause_circle_outline',
          UNFREEZE: 'play_circle_outline',
          COMPLETION: 'check_circle_outline'
        })[action.type]
      }}
    </mat-icon>

    <p
      *grecoTableCol="'Action'; let action"
      [class]="action.status"
      style="padding-right: 4px"
      [matTooltip]="(action.timestamp | date : 'medium') || ''"
    >
      <span *ngIf="action.status === 'SCHEDULED' || action.status === 'FROZEN'">
        <span *ngIf="action.status === 'FROZEN'">(Frozen) </span>
        Scheduled
        {{
          $any({
            START: 'to start',
            RENEWAL: 'for renewal',
            UPDATE: 'for update',
            CANCELLATION: 'final cycle ending',
            FREEZE: 'to freeze',
            UNFREEZE: 'to unfreeze',
            COMPLETION: 'final cycle ending'
          })[action.type]
        }}
        on {{ action.timestamp | date : 'medium' }}
      </span>
      <span *ngIf="action.status === 'COMPLETED'">
        {{
          $any({
            START: 'Started',
            RENEWAL: 'Renewed',
            UPDATE: 'Updated',
            CANCELLATION: 'Final cycle ended',
            FREEZE: 'Frozen',
            UNFREEZE: 'Unfrozen',
            COMPLETION: 'Final cycle ended'
          })[action.type]
        }}
        on {{ action.timestamp | date : 'medium' }}
      </span>
      <span
        *ngIf="
          (action.type === 'CANCELLATION' || action.type === 'FREEZE' || action.type === 'UNFREEZE') &&
          (action.proration || action.prorate)
        "
        >&nbsp;(prorated)</span
      >
    </p>

    <p *grecoTableCol="'Items'; let action" style="padding-right: 4px">
      <span>
        {{ action.itemsDisplayTitle || '' }}
      </span>
    </p>

    <ng-container *ngIf="canViewDetails$ | async">
      <p *grecoTableCol="'Created By'; let action" style="padding-right: 4px">
        <span>
          {{ action.createdBy?.displayName || '' }}
        </span>
      </p>

      <p *grecoTableCol="'Details'; let action" style="padding-right: 4px">
        <span>
          {{ action.lockedForProcessing ? 'Processing...' : '' }}
        </span>
        <span>
          {{ action.details ? action.details : '' }}
          {{ action.freeze ? '(' + action.freeze.reason + ')' : '' }}
        </span>
      </p>

      <p *grecoTableCol="'Prorate'; let action" style="padding-right: 4px">
        <!-- <span *ngIf="action.prorate"> Yes </span> -->
        <mat-checkbox [disabled]="true" color="primary" [checked]="action.prorate || action.proration"></mat-checkbox>
        <!-- <mat-checkbox [checked]="false" *ngIf="!action.prorate"></mat-checkbox> -->
        <!-- <span *ngIf="!action.prorate"> No </span> -->
      </p>
    </ng-container>

    <ng-container *ngIf="canMakeChange">
      <ng-container *grecoTableCol="''; let action; fitContent: true; stickyEnd: true">
        <greco-subscription-action-options-menu
          [action]="action"
          [communityId]="communityId"
          [subscription]="subscription"
          (scheduleChanged)="scheduledChanged.emit()"
        ></greco-subscription-action-options-menu>
      </ng-container>
    </ng-container>
  </greco-table>

  <mat-paginator
    *ngIf="_paginationMeta?.totalItems"
    showFirstLastButtons
    style="border-top: 1px solid lightgrey"
    [pageSizeOptions]="[5, 10]"
    [length]="_paginationMeta!.totalItems || 0"
    [pageSize]="_paginationMeta!.itemsPerPage || 5"
    (page)="pagination$.next({ page: $event.pageIndex + 1, limit: $event.pageSize })"
  ></mat-paginator>
</greco-collapsible-section>
